<div class="energy-map-container">
	<h1 class="text-center" [innerHTML]="textkeyPrefix + '.energy.map.headline' | translate"></h1>
	<div class="grid-x grid-margin-x">
		<div class="cell">
			<p class="description-2" [innerHTML]="textkeyPrefix + '.energy.map.description.2' | translate"></p>
		</div>
	</div>

	<div class="iframe-wrapper">
		<iframe id="iframe_gebaeudeauswahl" [src]="buildingSelectionUrl | safeUrl" width="100%" height="600"></iframe>
		<div *ngIf="selectedBuildings.length > 0" class="selected-building">
			<div class="text-above" [innerHTML]="textkeyPrefix + '.energy.map.selected.building.text.above' | translate"></div>
			<div *ngFor="let building of selectedBuildings">
				<strong [innerHTML]="building.street + ' ' + building.plz + ' Berlin'"></strong>
			</div>
			<div class="text-below" [innerHTML]="textkeyPrefix + '.energy.map.selected.building.text.below' | translate"></div>
		</div>
	</div>

	<div class="grid-x grid-margin-x">
		<div class="cell">
			<p>
				<a [routerLink]="nextStep" class="arrow-right"
				   (click)="buildingNotIncludedClicked()">{{textkeyPrefix + '.energy.map.button.building_is_not_included_in_map' | translate}}</a>
			</p>
		</div>
		<div class="cell shrink medium-3">
			<a class="button darker-gray hollow" [routerLink]="lastStep"><i class="icon-chevron-left"></i></a>
		</div>
		<div class="cell auto medium-5 medium-offset-4">
			<a [routerLink]="nextStepDonated" [class.disabled]="selectedBuildings.length <= 0" class="button primary inline-arrow-right"
			   (click)="submitClicked($event)"
			   [ngStyle]="selectedBuildings.length <= 0 ? {pointerEvents: 'none'} : ''">{{textkeyPrefix + '.energy.map.button.donate_data_now' | translate}}</a>
		</div>
	</div>
</div>
